import React, { useEffect, useState } from "react";
import { TextField, Button, Box, Typography, Grid, Autocomplete } from "@mui/material";
import { ReactComponent as PlushIcon } from "../../assets/dashboardIcons/plusicon.svg";
import { ReactComponent as Wifi } from "../../assets/dashboardIcons/wifiIcon.svg";
import { LocalizationProvider, DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import MenuWithPDF from "../filter/MenuWithPDF";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useDispatch, useSelector } from "react-redux";
import { fetchStabilimenti } from "../../features/stabilimenti/stabilimentiThunk";
import produzioniFormAPI from "../../services/produzioniFormApi";
dayjs.locale('it');

const TableInputFeildTransport = ({ option, rows, setRows, activeStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const stabiliOptions = useSelector((state) => state.stabilimenti.stabilimenti) || [];

    const { control, formState: { errors } } = useForm();
    // const [rows, setRows] = useState([
    //     { id: 1, departureDate: null, arrivalDate: null, destination: "", transportTemp: "", arrivalWeight: "", humidity: "" },
    //     { id: 2, departureDate: null, arrivalDate: null, destination: "", transportTemp: "", arrivalWeight: "", humidity: "" },
    //     { id: 3, departureDate: null, arrivalDate: null, destination: "", transportTemp: "", arrivalWeight: "", humidity: "" },
    // ]);

    useEffect(() => {
        dispatch(fetchStabilimenti());
    }, [dispatch])

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            {
                company_id: Number(localStorage.getItem('company_id')) || "",
                step: activeStep,
                prod_id: singleProduzioneID,
                departure_date_and_time: null,
                arrival_date_and_time: null,
                stabili_id: "",
                transport_temp: "",
                peso: "",
                humidity: ""
            }
        ]);
    };
    const handleDelete = async (index) => {
        const row = rows[index];
    
        if (row.id) {
          try {
            await produzioniFormAPI.deleteStepFormRow({
                id: row.id, 
                formName: "transporto"
            });
          } catch (err) {
            console.error("Error deleting row from server:", err);
            return;
          }
        }

        setRows((prev) => prev.filter((_, i) => i !== index));
      };
    // console.log(rows, "eows")
    return (
        <Box className="tableInput" sx={{ maxWidth: "100%", padding: 2 }}>
            <h3 className="sectiontitleSmall">Trasporti</h3>

            {/* Column Titles */}
            <Grid container spacing={1} sx={{ marginBottom: 1, fontWeight: "bold", color: "gray" }}>
                <Grid size={0.5}><Typography>ID</Typography></Grid>
                <Grid size={1.9}><Typography>Data e ora di partenza</Typography></Grid>
                <Grid size={1.9}><Typography>Data e ora di arrivo</Typography></Grid>
                <Grid size={1.9}><Typography>Stab. di destinazione</Typography></Grid>
                <Grid size={1.9}>
                    <Box className="inputBoxIcon heading">
                        <p>Temp. al trasporto</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
                <Grid size={1.9}>
                    <Box className="inputBoxIcon heading">
                        <p>Peso all'arrivo</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
                <Grid size={1.9}>
                    <Box className="inputBoxIcon heading">
                        <p>Umidità ambiente</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
            </Grid>

            {/* Dynamic Rows */}
            {rows?.map((row, index) => (
                <>
                    <Grid container spacing={1} key={index} sx={{ marginBottom: 1 }}>
                        <Grid size={0.5}>
                            <TextField
                                value={row?.id || index}
                                disabled
                                className="customTextBox"
                                label="ID"
                                size="small"
                            />
                        </Grid>

                        <Grid size={1.9}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                                <Controller
                                    name={`departureDate-${index}`}
                                    control={control}
                                    render={({ field }) => (
                                        <DateTimePicker
                                            className='datePickerField'
                                            label="Data e ora di partenza"
                                            value={row?.departure_date_and_time ? dayjs(row.departure_date_and_time) : null}
                                            onChange={(newValue) => {
                                                const formattedDateTime = dayjs(newValue).format("YYYY-MM-DD HH:mm");
                                                field.onChange(formattedDateTime);
                                                handleInputChange(index, "departure_date_and_time", formattedDateTime);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={!!errors[`departureDate-${index}`]}
                                                    helperText={errors[`departureDate-${index}`]?.message}
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>

                        <Grid size={1.9}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                                <Controller
                                    name={`arrivalDate-${index}`}
                                    control={control}
                                    render={({ field }) => (
                                        <DateTimePicker
                                            className='datePickerField'
                                            label="Data e ora di arrivo"
                                            value={row?.arrival_date_and_time ? dayjs(row.arrival_date_and_time) : null}
                                            onChange={(newValue) => {
                                                const formattedDateTime = dayjs(newValue).format("YYYY-MM-DD HH:mm");
                                                field.onChange(formattedDateTime);
                                                handleInputChange(index, "arrival_date_and_time", formattedDateTime);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={!!errors[`arrivalDate-${index}`]}
                                                    helperText={errors[`arrivalDate-${index}`]?.message}
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>


                        <Grid size={1.9}>
                            <Autocomplete
                                options={stabiliOptions}
                                getOptionLabel={(option) => option.nome}
                                value={stabiliOptions.find((option) => option.id == row.stabili_id) || null}
                                onChange={(event, newValue) => handleInputChange(index, "stabili_id", newValue.id)}
                                renderInput={(params) => (
                                    <TextField {...params} className="customTextBox autoCompleteTextBox" label="Stab. di destinazione" size="small" />
                                )}
                            />
                        </Grid>
                        <Grid size={1.9}>
                            <Box className="inputBoxIcon">
                                <TextField
                                    defaultValue=""
                                    className="customTextBox"
                                    label="Temp. al trasporto"
                                    onChange={(e) => handleInputChange(index, "transport_temp", e.target.value)}
                                    size="small"
                                    value={row.transport_temp}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>

                        <Grid size={1.9}>
                            <Box className="inputBoxIcon">
                                <TextField
                                    defaultValue=""
                                    className="customTextBox"
                                    label="Peso all'arrivo"
                                    onChange={(e) => handleInputChange(index, "peso", e.target.value)}
                                    size="small"
                                    value={row.peso}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>

                        <Grid size={1.9}>
                            <Box className="inputBoxIcon">
                                <TextField
                                    defaultValue=""
                                    className="customTextBox"
                                    label="Umidità ambiente"
                                    onChange={(e) => handleInputChange(index, "humidity", e.target.value)}
                                    size="small"
                                    value={row.humidity}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>
                        <Grid size={.1}>
                            <MenuWithPDF
                                options={option}
                                handleDelete={(event) => {
                                    event?.stopPropagation();
                                    handleDelete(index);
                                }}
                                id={row.id}
                            />
                        </Grid>
                    </Grid>

                </>
            ))}

            {/* Add Button */}
            <Button
                variant="body2"
                onClick={addRow}
                sx={{
                    cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
                    fontFamily: '"Public Sans", sans-serif !important',
                    '&:hover': {
                        color: '#57C700',
                        background: "transparent"
                    }
                }}
            >
                <PlushIcon /> aggiungi Trasporto
            </Button>
        </Box>
    );
};

export default TableInputFeildTransport;
